import React, { Component, Fragment } from 'react'
import Moment from 'react-moment'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import sortBy from 'array-sort-by'
import styled from 'styled-components'
import { licenseActions } from '../../actions'
import { pxToRem, color, format } from '../../utils'
import { Grid, Content } from '../../components/Layout'
import Sidebar from '../../components/Sidebar'
import Header from '../../components/Header'
import DataTable from '../../components/Table/Table'
import Modal from '../../components/Modal'
import { Select, Button } from '../../components/Form'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import statusDanger from '../../assets/icons/status-danger.svg'
import statusSuccess from '../../assets/icons/status-success.svg'
import statusWarning from '../../assets/icons/status-warning.svg'
import ContentHeader from '../../components/ContentHeader'
import dateToBrFormat from '../../utils/dateToBrFormat'

const WrapperStatus = styled.div`
  width: 20px;
  height: 20px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    margin: auto;
    max-width: 14px;
    max-height: 14px;
  }

  ${({ type }) => {
    return `background: ${color[type]};`
  }};
`

const WrapperStatusModal = styled(WrapperStatus)`
  display: inline-flex;
  margin-left: ${pxToRem(10)};
`

const WrapperFilters = styled.div`
  margin-bottom: ${pxToRem(10)};
`

const SelectFilter = styled.div`
  width: ${pxToRem(220)};
  height: ${pxToRem(40)};
  margin-left: auto;
  background: #fff;
`

const SelectArea = styled(Select)`font-size: ${pxToRem(14)};`

const ModalLayout = styled.div`
  display: flex;
  padding-left: ${pxToRem(20)};
  padding-right: ${pxToRem(20)};
  > div:first-child {
    padding-top: ${pxToRem(20)};
    padding-bottom: ${pxToRem(20)};
  }
  > div:last-child {
    flex: 1;
    padding: ${pxToRem(30)};
    padding-top: ${pxToRem(20)};
    padding-bottom: ${pxToRem(20)};
    border-left: 1px solid #d3dce2;
    margin-left: ${pxToRem(16)};
  }
  @media only screen and (max-width: 700px) {
    flex-direction: column;
    > div:last-child {
      border: none;
      padding-left: 0;
      margin-left: 0;
    }
  }
`

const DefinitionList = styled.dl`
  margin: 2em 0;
  &:first-child {
    margin-top: 0;
  }
  dd,
  dt {
    padding: 0;
    margin: 0;
    font-size: ${pxToRem(14)};
  }
  dd {
    span,
    strong {
      color: ${color.secondary};
    }
    strong {
      font-weight: bold;
    }
  }
  dt {
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 1em;
  }
  & > dl {
    overflow: auto;
    margin-top: 0;
    max-height: 260px;
  }
  dl {
    &:first-child {
      margin-top: 0;
    }
    dt {
      color: ${color.primary};
      margin-bottom: 0;
      font-weight: bold;
    }
  }
`

const LicenseLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const columns = {
  id: {
    hide: true
  },
  name: {
    label: 'Licença',
    sortable: true,
    width: 210
  },
  license_issuer_name: {
    label: 'Órgão Emissor',
    sortable: true,
    width: 150
  },
  issue_date: {
    label: 'Data de Emissão',
    sortable: true,
    width: 150,
    format: date => format.date(date)
  },
  due_date: {
    label: 'Data de Vencimento',
    sortable: true,
    width: 160,
    format: date => format.date(date)
  },
  status: {
    label: 'Status',
    sortable: true,
    width: 40,
    sort: ({ mapedColumns = [], sortByColumn, reverseSort }) => {
      return sortBy(mapedColumns, item => {
        return reverseSort ? `desc:${item[sortByColumn].icon}` : item[sortByColumn].icon
      })
    },
    CellComponent: ({ name, value }) => {
      let icon

      if (value.icon === 'success') {
        icon = statusSuccess
      }

      if (value.icon === 'danger') {
        icon = statusDanger
      }

      if (value.icon === 'warning') {
        icon = statusWarning
      }

      return (
        <WrapperStatus data-tip={value.info} type={value.icon}>
          <span aria-hidden={true}>
            <img src={icon} alt={value.info} />
          </span>
          <ReactTooltip place="bottom" type="light" effect="solid" className="exo-gpq-tooltip" />
        </WrapperStatus>
      )
    }
  }
}

class License extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openLicenseModal: false,
      areaAdded: false,
      areaName: '',
      areaId: null
    }
  }

  componentDidMount() {
    this.props.fetchInitialState()
    this.props.fetchAreas()
  }

  componentDidUpdate() {
    if (this.props.areas.length > 0 && !this.state.areaAdded) {
      let area = this.props.areas[0]
      this.changeArea(area)

      this.setState(state => ({
        areaAdded: true,
        areaName: area.label,
        areaId: area.value
      }))
    }
  }

  componentWillUpdate({ searchText = '' }) {
    if (searchText !== this.props.searchText) {
      const debounce = setTimeout(() => {
        this.props.fetchLicensesForArea(this.state.areaId, searchText, this.props.thirdParty)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  closeModal = () => {
    this.setState(state => ({
      openLicenseModal: false
    }))
  }

  openModal = (e, id) => {
    e.preventDefault()
    this.props.fetchLicense(id)
    this.setState(state => ({
      openLicenseModal: true
    }))
  }

  changeArea = (area) => {
    if (!!area.value) {
      this.props.fetchLicensesForArea(area.value, this.props.searchText, this.props.thirdParty)
    } else {
      this.props.fetchInitialState()
    }

    this.setState(state => ({
      areaName: area.label,
      areaId: area.value
    }))
  }

  render() {
    const {
      menuItems = [],
      router,
      fetchLicenses,
      licenses,
      last_update,
      fetching,
      license,
      fetch_errors,
      areas
    } = this.props
    const { closeModal, openModal, changeArea } = this
    const { openLicenseModal, areaName, areaId } = this.state
    const CellComponent = ({ name, value, row, ...rest }) => {
      return (
        <LicenseLink {...rest} onClick={e => openModal(e, row.id)}>
          {value}
        </LicenseLink>
      )
    }
    columns['name'] = { ...columns['name'], CellComponent }
    let icon
    if ((license['status'] || {}).icon === 'success') {
      icon = statusSuccess
    }
    if ((license['status'] || {}).icon === 'danger') {
      icon = statusDanger
    }
    if ((license['status'] || {}).icon === 'warning') {
      icon = statusWarning
    }
    const subtitle = this.props.thirdParty ? "Licenças de terceiros" : "Licenças"

    return (
      <Fragment>
        <Grid>
          <Header search router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content scapeSearch>
            <ContentHeader
              title="Produtos Controlados"
              subtitle={subtitle}
              last_update={last_update ? dateToBrFormat(new Date(last_update)) : '---'}
            />
            <div>
              <WrapperFilters>
                <SelectFilter>
                  <SelectArea
                    placeholder={"Selecione uma área"}
                    value={{ label: areaName, value: areaId }}
                    onChange={value => {
                      changeArea(value)
                    }}
                    options={[...areas]}
                  />
                </SelectFilter>
              </WrapperFilters>
            </div>
            <DataTable
              loading={fetching.licenses}
              error={fetch_errors.licenses}
              fetchData={fetchLicenses}
              columns={columns}
              height={900}
              width={1100}
              data={licenses}
              defaultSort={{ key: 'name', reverse: false }}
            />
            <ResponsiblesContent />
          </Content>
        </Grid>
        <Modal
          title={license.name}
          safeContent={false}
          loading={fetching.license}
          open={openLicenseModal}
          size={'large'}
          error={fetch_errors.license}
          closeMethod={closeModal}
        >
          <ModalLayout>
            <div>
              <DefinitionList>
                <dt>Data de Emissão</dt>
                <dd>
                  {license['issue_date'] ? (
                    <Moment element={'span'} format={'DD/MM/YYYY'}>
                      {license['issue_date']}
                    </Moment>
                  ) : (
                    <span>---</span>
                  )}
                </dd>
              </DefinitionList>
              <DefinitionList>
                <dt>Data de Vencimento</dt>
                <dd>
                  {license['due_date'] ? (
                    <Moment element={'span'} format={'DD/MM/YYYY'}>
                      {license['due_date']}
                    </Moment>
                  ) : (
                    <span>---</span>
                  )}
                </dd>
              </DefinitionList>
              <DefinitionList>
                <dt>
                  Status
                  <WrapperStatusModal type={(license['status'] || {}).icon}>
                    <span>
                      <img src={icon} alt={(license['status'] || {}).info} />
                    </span>
                  </WrapperStatusModal>
                </dt>
                <dd>
                  <strong>{(license['status'] || {}).info}</strong>
                </dd>
              </DefinitionList>
              {!!license['document_path'] && (
                <Button link href={license['document_path']} target="_blank">
                  Ver Original
                </Button>
              )}
            </div>
            <div>
              <DefinitionList>
                <dt>Número</dt>
                <dd>{license['number']}</dd>
              </DefinitionList>
              <DefinitionList>
                <dt>Finalidade</dt>
                <dd>{license['finality']}</dd>
              </DefinitionList>
              <DefinitionList>
                <dt>Observações</dt>

                {!!(license['notes'] || []).length ? (
                  <dl>
                    {sortBy(license['notes'] || [], item => -new Date(item.updated_at)).map(
                      (note, index) => {
                        return (
                          <dl key={index}>
                            <dt>
                              {note['updated_at'] ? (
                                <Moment element={'span'} format={'DD/MM/YYYY - HH:mm'} locale={'pt-br'}>
                                  {note['updated_at']}
                                </Moment>
                              ) : (
                                <span>---</span>
                              )}
                            </dt>
                            <dd>{note.content}</dd>
                          </dl>
                        )
                      }
                    )}
                  </dl>
                ) : (
                  <dl>
                    <dd>Nenhum registro encontrado</dd>
                  </dl>
                )}
              </DefinitionList>
              <DefinitionList>
                <dt>Area</dt>
                <dd>{license['area_name']}</dd>
              </DefinitionList>
            </div>
          </ModalLayout>
        </Modal>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  licenses: state.license.items,
  last_update: state.license.last_update,
  license: state.license.license,
  fetching: state.license.fetching,
  fetch_errors: state.license.fetch_errors,
  areas: state.license.areaList,
  can_change_area: state.auth.can_change_area,
  searchText: state.search.searchText,
})

const mapDispatchToProps = dispatch => {
  return {
    fetchInitialState: () => {
      dispatch(licenseActions.fetchInitialState())
    },
    fetchLicenses: () => {
      dispatch(licenseActions.fetchLicenses())
    },
    fetchLicense: id => {
      dispatch(licenseActions.fetchLicense(id))
    },
    fetchLicensesForArea: (areaId, term, thirdParty = false) => {
      dispatch(licenseActions.fetchLicensesForArea(areaId, term, thirdParty))
    },
    fetchAreas: () => {
      dispatch(licenseActions.fetchAreasList())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(License)



// WEBPACK FOOTER //
// ./src/containers/ControlledProducts/License.js